module.exports = __webpack_public_path__ + "static/media/ESPOL-extracurriculares.f98f5dfc.svg";